export function useUser() {
    const userJson = localStorage.getItem('user');
    const user = userJson ? JSON.parse(userJson) : null;
    return user;
}

export function useAuthToken() {
    return localStorage.getItem('authToken');
}